export interface CustomPuzzleImageMetadata {
  originalUrl: string;
  croppedUrl: string;
  crop: {
    x: number; // Percentage 0-100
    y: number; // Percentage 0-100
    width: number; // Percentage 0-100
    height: number; // Percentage 0-100
  };
  originalDimensions: {
    width: number; // Pixels
    height: number; // Pixels
  };
  timestamp?: number; // For cache busting
}

export function parseImageMetadata(metadataValue: string | undefined): CustomPuzzleImageMetadata | null {
  if (!metadataValue) return null;

  try {
    const parsed = JSON.parse(metadataValue);
    // Verify it's the new format by checking for required properties
    if (parsed.originalUrl && parsed.croppedUrl && parsed.crop && parsed.originalDimensions) {
      return parsed as CustomPuzzleImageMetadata;
    }
    return null;
  } catch {
    // Not JSON - could be old format (direct URL string)
    return null;
  }
}

export function stringifyImageMetadata(metadata: CustomPuzzleImageMetadata): string {
  return JSON.stringify(metadata);
}
